export const CSRF_TOKEN = document.head.querySelector('meta[name="csrf-token"]').content;
